import { collectOffsetPages } from '../../shared/collectOffsetPages';
import type { ApiClient } from '../../api/client';
import type {
  BulkOperationDetail,
  BulkOperationJob,
  BulkOperationsPort,
} from '../../features/bulk/public';

type BulkOperationCollection = {
  total: number;
  data: BulkOperationJob[];
};

const bulkOperationPageSize = 100;

async function listAllBulkOperations(client: ApiClient): Promise<BulkOperationJob[]> {
  const collection = await collectOffsetPages((offset) => client.requestTenant<BulkOperationCollection>(
    `/api/hr/v1/{tenant}/bulkOperations?limit=${bulkOperationPageSize}&offset=${offset}`,
  ), bulkOperationPageSize);
  return collection.data;
}

export function createBulkOperationsHttpAdapter(client: ApiClient): BulkOperationsPort {
  return {
    listBulkOperations() {
      return listAllBulkOperations(client);
    },

    getBulkOperation(id: string) {
      return client.requestTenant<BulkOperationDetail>(`/api/hr/v1/{tenant}/bulkOperations/${encodeURIComponent(id)}`);
    },

    createBulkOperation(
      operationType: string,
      originalFilename: string,
      rows: Array<Record<string, string>>,
      idempotencyKey: string,
    ) {
      return client.requestTenant<BulkOperationDetail>('/api/hr/v1/{tenant}/bulkOperations', {
        method: 'POST',
        headers: { 'Idempotency-Key': idempotencyKey },
        body: JSON.stringify({ operationType, originalFilename, rows }),
      });
    },

    submitBulkOperation(id: string, idempotencyKey = crypto.randomUUID()) {
      return client.requestTenant<BulkOperationJob>(`/api/hr/v1/{tenant}/bulkOperations/${encodeURIComponent(id)}/submit`, {
        method: 'POST',
        headers: { 'Idempotency-Key': idempotencyKey },
        body: '{}',
      });
    },
  };
}
